<template>
  <div class="link-main">
      <img class="links-title" src="./../assets/img/links-title.png" alt="">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item,index) in linklist" :key="index">
            <div style="padding:0 13px;"><img style="width:165px;height:50px;"  :src="item.linkimg" /></div>
        </swiper-slide>
        
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
  </div>
</template>

<script>
export default {
data(){
    return{
        linklist:[
            {
                linkimg:require('./../assets/img/link1.png')
            },
            {
                linkimg:require('./../assets/img/link2.png')
            },
            {
                linkimg:require('./../assets/img/link3.png')
            },
            {
                linkimg:require('./../assets/img/link4.png')
            },
            {
                linkimg:require('./../assets/img/link5.png')
            },
            {
                linkimg:require('./../assets/img/link6.png')
            },
            {
                linkimg:require('./../assets/img/link7.jpg')
            },
            {
                linkimg:require('./../assets/img/link8.jpg')
            },
            {
                linkimg:require('./../assets/img/link9.jpg')
            },
            {
                linkimg:require('./../assets/img/link10.jpg')
            },
            {
                linkimg:require('./../assets/img/link11.png')
            },
            {
                linkimg:require('./../assets/img/link12.png')
            },
            {
                linkimg:require('./../assets/img/link13.png')
            }
        ],
        swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: true,
        slidesPerView :6,
        // 自动轮播
        speed: 2000, // 匀速时间
        autoplay:true,
        grabCursor: true
        // Some Swiper option/callback...
      }
    }
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/link.vue